<template lang="pug">
div.actor-query-options.query-options.columns

    div.column.is-5.is-left

        search-option-input-text(
            v-model="options"
            v-bind:on-enter="onSearch"
            v-bind:autofocus="true"
            v-bind:placeholder="$t('actors.search.placeholder')")

    //- div.column.is-right
    //-     div.query-option.disabled
    //-         span {{ $t('actors.search.byDate') }}
    //-         icon-chevron-down(title='')
    //-     // div.query-option.disabled
    //-     //     span {{ $t('actors.search.byTechnique') }}
    //-     //     icon-chevron-down(title='')
    //-     // div.query-option.disabled
    //-     //     span {{ $t('actors.search.byStyle') }}
    //-     //     icon-chevron-down(title='')
    //-     div.query-option.disabled
    //-         span {{ $t('actors.search.byAtoZ') }}
    //-         icon-chevron-down(title='')
</template>

<script>
// import SearchOptionInputText from '@/components/SearchOptions/InputText';

/**
 * QueryOptions
 */
export default {
    name: 'actor-query-options',

    props: {
        value: {        type: Object, default: () => { return {Text: ''}; } },
        mode: {         type: String, default: 'search' } // index || search
    },

    components: {
        // SearchOptionInputText
    },

    data: function () {
        return {
            options: {} // options is a buffer between the bound v-model "this.value" internal options
        };
    },

    mounted: function () {
        this.initOptions();
    },

    watch: {
        $route: function () {
            this.initOptions();
        }
    },

    methods: {
        initOptions: function () {
            const query = this.$route && this.$route.query;
            const text = (query && query.Text) || '';
            this.options = _.extend({}, {
                Text: text
            }, this.value);
        },

        onSearch: function () {
            // emit search signal with current options
            this.$emit('search', this.options);
        }
    }
};
</script>

<style scoped lang="scss">
// @import '~assets/styles/mixins';
.actor-query-options {
    .search-input-text {
        width: 100%;
    }
}
</style>
